export default "__VITE_ASSET__DVJfkciJ__"